export function EnterIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M18 6a1 1 0 10-2 0v8H7.414l1.293-1.293a1 1 0 10-1.414-1.414l-3 3a.997.997 0 00-.294.705l.001.002v.003a.997.997 0 00.293.704l3 3a1 1 0 001.414-1.414L7.414 16H17a1 1 0 001-1V6z"
      ></path>
    </svg>
  );
}
